<div class="file-upload-component">
  <tbs-upload [tbsAccept]="fileTypes()" [tbsBeforeUpload]="beforeUpload" (tbsChange)="onUpload($event)">
    <button tbs-button tbsType="text" tbsIconPosition="left">
      <tbs-icon icon="calcite:upload-24" />
      {{ title() }}
    </button>
  </tbs-upload>

  @if (note()) {
    <span class="note tb-caption" [innerHTML]="note()"></span>
  }
  @if (errorMessage()) {
    <span class="error tb-caption">{{ errorMessage() }}</span>
  }
</div>
